import {
    kuidListeners,
    sendGTMUserHash,
} from "tsi-common-react/src/utils/analytics";

// Update the user hash in GTM on page load
sendGTMUserHash();
kuidListeners();
